module.exports = __webpack_public_path__ + "static/media/post-img1.f64ecd0c.jpg";